import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlarmData } from '../services/getHealthSummaryService'

export interface HealthSummaryState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: HealthSummaryState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const healthSummarySlice = createSlice({
  name: 'HealthSummaryState',
  initialState,
  reducers: {
    healthSummaryLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    healthSummaryUpdateAction: (state, action: PayloadAction<{ data: AlarmData[], httpStatus: number }>) => {
      console.log(action, 'datadatasa')
      return {
        isLoading: false,
        error: undefined,
        data: action.payload,
        httpStatus: action.payload.httpStatus
      }
    },
    healthSummaryErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    },
    healthSummaryWebSocketUpdateAction: (state, action: PayloadAction<AlarmData[]>) => {
      return {
        ...state,
        data: {
          ...state.data,
          data: action.payload
        }
      }
    }
  }
})

export const {
  healthSummaryLoadingAction,
  healthSummaryUpdateAction,
  healthSummaryErrorAction,
  healthSummaryWebSocketUpdateAction
} = healthSummarySlice.actions

export default healthSummarySlice.reducer
